<template>
  <div class="app-container">
    <div
      class="bg-wrapper"
      :style="bgLoaded ? { backgroundImage: `url(${bgUrl})` } : {}"
    ></div>

    <FeedbackPanel />
    <LoadingScreen v-if="loading" />

    <div v-else class="layout-wrapper">
      <Header />
      <main class="main-content">
        <router-view @login-success="refreshUser" />
      </main>
      <a href="https://wa.me/905015713333" target="_blank" class="whatsapp-button">💬 WhatsApp</a>
      <Footer />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FeedbackPanel from '@/components/FeedbackPanel.vue'
import LoadingScreen from '@/components/LoadingScreen.vue'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'

// ✅ Webpack'in işleyebileceği şekilde görseli import et
import aiosImage from '@/assets/images/aios.webp'

const loading = ref(true)
const bgLoaded = ref(false)
const bgUrl = ref('')

const userStore = useUserStore()
const { user } = storeToRefs(userStore)

function refreshUser() {
  userStore.loadUser()
}

onMounted(() => {
  userStore.loadUser()
  window.addEventListener('login-success', refreshUser)

  document.title = "Osmanlıca Belge Tercümesi | Osmanlıca Belgeler"

  const metas = [
    { name: "description", content: "Osmanlıca belgelerinizin tercümesini uzman ekibimizle hızlı ve güvenilir şekilde yapıyoruz." },
    { name: "keywords", content: "Osmanlıca tercüme, belge çevirisi, noter yeminli tercüme, apostil tercüme, Online çeviri, Osmanlıca belge, çeviri ofisi" },
    { name: "author", content: "Osmanlıca Belgeler" }
  ]
  metas.forEach(m => {
    const el = document.createElement('meta')
    el.name = m.name
    el.content = m.content
    document.head.appendChild(el)
  })

  // ✅ Görsel yüklemesi tamamlanınca göster
  const img = new Image()
  img.src = aiosImage
  img.onload = () => {
    bgUrl.value = aiosImage
    bgLoaded.value = true
  }

  setTimeout(() => {
    loading.value = false
  }, 3000)
})

onBeforeUnmount(() => {
  window.removeEventListener('login-success', refreshUser)
})
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
  font-family: Arial, sans-serif;
  
}


.bg-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: -1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  flex: 1;
}

.main-content {
  flex: 1;
  padding: 0;
}

.whatsapp-button {
  position: fixed;
  bottom: 10px;
  right: 5px;
  background-color: #25D366;
  color: white;
  padding: 12px 18px;
  border-radius: 30px;
  font-weight: bold;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  text-decoration: none;
  z-index: 9999;
  transition: background-color 0.3s ease;
}

.whatsapp-button:hover {
  background-color: #1ebea5;
}

@media (max-width: 768px) {
  .main-content {
    padding: 10px;
  }

  .whatsapp-button {
    bottom: 15px;
    right: 10px;
    padding: 10px 14px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .whatsapp-button {
    font-size: 13px;
    padding: 8px 12px;
  }
}
</style>
